module.exports = {
	name: 'date',
	validation(yup) {
		return yup.date();
	}
};
